module.exports = "/assets/data/369f90f6c968b990d97f60dc78d28aba-BL4.data.json";